import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React from "react";
import { VersionTracker } from "./version-tracker";

const Navigation = dynamic(
  () => import("./navigation").then((mod) => ({
    default: mod.Navigation
  })),
  {
    ssr: false,
    placeholder: <div className="h-24">hello</div>,
  }
);
const TeamsDropdown = dynamic(
  () => import("./teams-dropdown").then((mod) => ({
    default: mod.TeamsDropdown
  })),
  {
    ssr: false,
  }
);
const UserDropdown = dynamic(
  () => import("./user-dropdown").then((mod) => ({
    default: mod.UserDropdown
  })),
  {
    ssr: false,
  }
);

const Logo = React.memo(() => {
  return (
    <img
      className="hidden w-auto h-5 md:block"
      src={`/assets/logo/white-icon.svg`}
      alt="Apollo Logo"
    />
  );
});

export const Header = React.memo(() => {
  const { pathname, asPath, push, query } = useRouter();

  const handleLogoClick = React.useCallback(() => {
    push("/programs");
  }, [pathname, asPath]);

  return (
    <nav
      key={query?.bootcampId}
      id="top-navigation"
      className="sticky top-0 z-50 hidden bg-background border-b border-white/[0.06] md:block"
    >
      <div className="hidden md:block w-full">
        <div className="w-full px-4 py-2">
          <div className="flex items-center justify-center relative w-full min-h-[40px]">
            <div className="flex items-center absolute left-0 gap-2">
              <button
                onClick={handleLogoClick}
                className="rounded flex items-center flex-shrink-0"
              >
                <Logo />
              </button>
              <div aria-hidden="true" className="text-white/10 text-lg font-light select-none">/</div>
              <TeamsDropdown />
            </div>
            <Navigation />
            <div className="absolute right-0 flex items-center">
              <VersionTracker>
                <UserDropdown />
              </VersionTracker>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
});
